import styled from 'styled-components';

export const SheetDetail = styled.div`
  margin: 0 -16px;
`;
